import { Form, FormField, FormFieldConditions, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { TrasiegoModel } from 'src/app/models/visitas/trasiego.model';


export class VisitasTrasiegoListModalFormDefinition {
  public readonly formFields: Form<TrasiegoModel>;
  public readonly model: Partial<TrasiegoModel>;

  constructor(type: FormType, model: Partial<TrasiegoModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'visitas-trasiego-list-modal',
      header: 'Datos del trasiego',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<TrasiegoModel>[] {
    const fields: FormField<TrasiegoModel>[] = [
      this.textField('finca_nombre', 'Explotación', 1, true, 4),
      this.textField('parcela_nombre', 'Subparcela', 2, true, 4),
      this.textField('trampa', 'Trampa', 3, true, 4),
    ];

    for (let index = 1; index <= 6; index++) {
      fields.push(this.textField(`plaga${index}`, `Plaga #${index}`, fields.length + 1, true, 6));
      fields.push(this.textField(`cantidad${index}`, `Cantidad #${index}`, fields.length + 1, true, 6));
    }

    return [{ name: '', fields, width: 12, isVisible: true, order: 1 }];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<TrasiegoModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
